import React from 'react';
import HyperGateIconCustom from '../CustomIcons/HyperGateIconCustom.jsx';

class GatewayChip extends React.Component {
  onHandleClick(event) {
    const { gatewayId, onClick } = this.props;
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (gatewayId !== undefined && gatewayId !== null && onClick) {
      onClick(gatewayId);
    }
  }

  render() {
    const { label, gatewayId, onClick } = this.props;
    const isClickable = gatewayId !== undefined && gatewayId !== null && onClick;

    return (
      <div
        role={isClickable ? 'button' : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onClick={isClickable ? event => this.onHandleClick(event) : undefined}
        onKeyDown={isClickable ? (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            this.onHandleClick(event);
          }
        } : undefined}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: '4px 12px',
          borderRadius: 16,
          backgroundColor: '#f0f0f0',
          color: '#3f3f3f',
          fontSize: 13,
          fontWeight: 600,
          cursor: isClickable ? 'pointer' : 'default',
        }}
      >
        <HyperGateIconCustom style={{ width: 16, height: 16, marginRight: 6, flexShrink: 0 }} />
        <span style={{ lineHeight: 1.2 }}>{label}</span>
      </div>
    );
  }
}

export default GatewayChip;
